import api from '@/apis'

export default {
  state: {
    visibility: false,
    headers: [
      { text: 'Group', value: 'name', sortable: false },
      { text: '', value: 'action', width: 134 }
    ],
    group_list: [],
    is_submit_disable: false,
    loading: false,
    search: ''
  },
  mutations: {
    INIT_MANAGE_GROUP_DIALOG(state) {
      state.visibility = true
    },
    SET_MANAGE_GROUP_DIALOG_GROUP_LIST(state, payload) {
      state.group_list = payload
    },
    RESET_MANAGE_GROUP_DIALOG(state) {
      state.visibility = false
    },
    SET_MANAGE_GROUP_DIALOG_IS_SUBMIT_DISABLE(state, payload) {
      state.is_submit_disable = payload
    },
    SET_MANAGE_GROUP_DIALOG_LOADING(state, payload) {
      state.loading = payload
    },
    SET_MANAGE_GROUP_DIALOG_SEARCH(state, payload) {
      state.search = payload
    }
  },
  actions: {
    async fetchGroupList({ state, commit }) {
      try {
        commit('SET_MANAGE_GROUP_DIALOG_GROUP_LIST', [])
        commit('SET_MANAGE_GROUP_DIALOG_LOADING', true)
        const response = await api.getGroupList({ search: state.search })
        if (response.data.success) {
          commit('SET_MANAGE_GROUP_DIALOG_GROUP_LIST', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_MANAGE_GROUP_DIALOG_LOADING', false)
      }
    },
    async addGroup({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Adding group...', loading: true })
        commit('SET_MANAGE_GROUP_DIALOG_IS_SUBMIT_DISABLE', true)

        const response = await api.addGroup({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          dispatch('fetchGroupList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_MANAGE_GROUP_DIALOG_IS_SUBMIT_DISABLE', false)
      }
    },
    async updateGroup({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Updating group...', loading: true })
        commit('SET_MANAGE_GROUP_DIALOG_IS_SUBMIT_DISABLE', true)

        const response = await api.updateGroup({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          commit('RESET_MANAGE_GROUP_DIALOG')
          dispatch('fetchGroupList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_MANAGE_GROUP_DIALOG_IS_SUBMIT_DISABLE', false)
      }
    }
  }
}
